import { useEffect, useState } from "react";
import { Button, Modal, Form, Row, Col, Input, Select, message } from "antd";
import fetchAllContacts from "../../../../services/fetchAllContacts";
import { RequiredMark } from "antd/lib/form/Form";
import updateVehicle from "../../../../services/updateVehicle";

const { Option } = Select;
const { TextArea } = Input;

export default function UpdateVehicle({
  isVisible,
  selected,
  setUpdateModal,
  refetch,
}: any) {
  const [contacts, setContacts] = useState<any>([]);

  const [requiredMark, setRequiredMarkType] =
    useState<RequiredMark>("optional");

  const [form] = Form.useForm();

  const onSubmit = async () => {
    const values = await form.validateFields();

    const response = await updateVehicle({
      vehicle_id: selected?._id,
      data: values,
    });
    if (response.success) {
      refetch();
      message.success("Vehicle updated successfully");
    } else {
      message.error(response.message);
    }
    setUpdateModal(false);
  };

  const handleFetchContacts = async () => {
    const data = await fetchAllContacts();
    setContacts(data?.payload);
  };

  const hideModal = () => {
    setUpdateModal(false);
  };

  useEffect(() => {
    form.resetFields();
    handleFetchContacts();
  }, [selected]);

  const clearForm = async () => {
    form.resetFields();
  };

  const contactOptions = contacts?.map((contact: any, index: number) => {
    return (
      <Option value={contact._id} key={index}>
        {contact?.customer?.name}
      </Option>
    );
  });

  return (
    <Modal
      visible={isVisible}
      title="Update Vehicle"
      onCancel={hideModal}
      footer={[
        <Button danger key="back" onClick={clearForm}>
          Clear
        </Button>,
        <Button
          danger
          key="submit"
          form="updateVehicle"
          htmlType="submit"
          type="primary"
          onSubmit={onSubmit}
        >
          Submit
        </Button>,
      ]}
    >
      <Form
        id="updateVehicle"
        form={form}
        name="normal_login"
        className="login-form"
        onFinish={onSubmit}
        layout="vertical"
        initialValues={{ requiredMarkValue: requiredMark }}
        requiredMark={requiredMark}
      >
        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="registration"
              label="Registration"
              initialValue={selected?.registration}
              rules={[
                {
                  required: true,
                  message: "Please enter registration",
                },
              ]}
            >
              <Input placeholder="Registration" />
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="chassis"
              label="Chassis"
              initialValue={selected?.chassis}
              rules={[
                {
                  required: true,
                  message: "Please enter chassis number",
                },
              ]}
            >
              <Input placeholder="Chassis" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="make"
              label="Make"
              initialValue={selected?.make}
              rules={[
                {
                  required: true,
                  message: "Please enter make",
                },
              ]}
            >
              <Input placeholder="Make" />
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="model"
              label="Model"
              initialValue={selected?.model}
              rules={[
                {
                  required: true,
                  message: "Please enter model",
                },
              ]}
            >
              <Input placeholder="Model" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="year"
              label="Year"
              initialValue={selected?.year}
              rules={[
                {
                  required: true,
                  message: "Please enter year",
                },
              ]}
            >
              <Input placeholder="Year" />
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="mileage"
              label="Mileage"
              initialValue={selected?.mileage}
              rules={[
                {
                  required: true,
                  message: "Please enter mileage",
                },
              ]}
            >
              <Input placeholder="Mileage" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 24 }}>
            <Form.Item
              name="contact"
              label="Contact"
              initialValue={selected?.contact?._id}
              rules={[
                {
                  required: true,
                  message: "Please select contact",
                },
              ]}
            >
              <Select
                showSearch
                placeholder="Search to Select"
                optionFilterProp="children"
                filterOption={(input: any, option: any) =>
                  option?.children
                    ?.toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                {contactOptions}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} lg={{ span: 24 }}>
            <Form.Item
              name="description"
              label="Description"
              initialValue={selected?.description}
              rules={[
                {
                  required: false,
                  message: "Please enter description",
                },
              ]}
            >
              <TextArea placeholder="Description" />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
